import React from 'react';
import GenericDialog from '../../../../components/dialog/GenericDialog';

import ModifyOperatorTab from './ModifyOperatorTab';
import RefranchiseOperatorTab from './RefranchiseOperatorTab';

export default function OperatorActionsDialog({
  open,
  initialData,            
  onClose,
  onSubmit,              
  defaultTabKey = 'modify',
}) {
  const tabs = [
    {
      key: 'modify',
      label: 'Modify Details',
      render: (helpers) => (
        <ModifyOperatorTab initialData={initialData} onSubmit={onSubmit} helpers={helpers} />
      ),
      actions: ({ close, loading }) => null, 
    },
    {
      key: 'refranchise',
      label: 'Transfer',
      render: (helpers) => (
        <RefranchiseOperatorTab initialData={initialData} onSubmit={onSubmit} helpers={helpers} />
      ),
      actions: ({ close, loading }) => null,
    },
  ];

  return (
    <GenericDialog
      open={open}
      onClose={onClose}
      title="Operator Actions"
      tabs={tabs}
      defaultTabKey={defaultTabKey}
      maxWidth="xs"
      renderHeaderExtras={() => null}
    />
  );
}
